import "./ShopPageFocusItem.css";

import React from "react";

import { useEffect, useState, useRef } from "react";

import { useOutletContext, Link } from "react-router-dom";

import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";

import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import CheckIcon from "@mui/icons-material/Check";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export const ShopPageFocusItem = () => {
  let utilityProps = useOutletContext();
  let urlArr = window.location.href.split(":");
  let itemIdUrl = urlArr[2];

  const DescriptionButton = useRef(null);

  const cardImgRef = useRef(null);

  const [itemData, setItemData] = useState({});
  const [itemSizes, setItemSizes] = useState([]);
  const [itemCountFieldValue, setItemCountFieldValue] = useState(1);
  const [addItemSiccess, setAddItemSiccess] = useState(false);

  const [categories, setCategories] = useState(["asd", "dsa"]);

  const [selectedSize, setSelectedSize] = useState("");
  const [availableQuantity, setAvailableQuantity] = useState(1);

  const [imgsArray, setImgsArray] = useState("");
  const [selectedImg, setSelectedImg] = useState(0);

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setAddItemSiccess(false);
  };

  const handleToImg1 = (e) => {
    cardImgRef.current.style.opacity = "0%";
    setTimeout(() => {
      setSelectedImg(0);
      cardImgRef.current.style.opacity = "100%";
    }, 400);
  };
  const handleToImg2 = (e) => {
    cardImgRef.current.style.opacity = "0%";
    setTimeout(() => {
      setSelectedImg(1);
      cardImgRef.current.style.opacity = "100%";
    }, 400);
  };
  const handleToImg3 = (e) => {
    cardImgRef.current.style.opacity = "0%";
    setTimeout(() => {
      setSelectedImg(2);
      cardImgRef.current.style.opacity = "100%";
    }, 400);
  };
  const handleToImg4 = (e) => {
    cardImgRef.current.style.opacity = "0%";
    setTimeout(() => {
      setSelectedImg(3);
      cardImgRef.current.style.opacity = "100%";
    }, 400);
  };
  const handleSelectSize = (e) => {
    itemSizes.map((item) => {
      if (e.target.value === item.size) {
        setAvailableQuantity(item.availableQuantity);
      }
    });
    setSelectedSize(e.target.value);
  };
  const handleItemCountChange = (event) => {
    setItemCountFieldValue(event.target.value);
  };

  const handleFocusItemAddToCart = () => {
    if (selectedSize === "" || availableQuantity === 0) {
      setOpen(true);
    } else {
      utilityProps[3](itemIdUrl, itemCountFieldValue, selectedSize);
      setAddItemSiccess(true);
      setOpen(true);
    }
  };

  const handleCategoryRedirect = (event) => {
    utilityProps[7](event.target.id);
    utilityProps[6](false);
  };

  useEffect(() => {
    if (window.location.href !== "https://new-football-boots/shop") {
      utilityProps[6](true, itemIdUrl);
      console.log(itemIdUrl);
    }
    utilityProps[8]();
    utilityProps[0].map((item) => {
      if (item.id === itemIdUrl) {
        let availableSizes = [];
        item.sizes.map((size) => {
          if (size.availableQuantity > 0) {
            availableSizes.push(size);
          }
        });
        setItemData(item);
        setCategories(item.category);
        setItemSizes(availableSizes);
        setImgsArray([item.imgId1, item.imgId2, item.imgId3, item.imgId4]);
      }
    });
  }, []);
  return (
    <div className="shop-page-focus-item-container">
      <div className="shop-page-section-one-container">
        <div className="shop-page-section-one-imgs-container">
          <img
            ref={cardImgRef}
            className="shop-page-section-one-img"
            src={imgsArray[selectedImg]}
            alt="Loading"
          ></img>
          <div className="shop-card-image-selectors-container">
            <img
              src={itemData.imgId1}
              alt="Loading"
              className="shop-card-image-selectors-1"
              onClick={handleToImg1}
            />
            <img
              src={itemData.imgId2}
              alt="Loading"
              className="shop-card-image-selectors-2"
              onClick={handleToImg2}
            />

            <img
              src={itemData.imgId3}
              alt="Loading"
              className="shop-card-image-selectors-3"
              onClick={handleToImg3}
            />

            <img
              src={itemData.imgId4}
              alt="Loading"
              className="shop-card-image-selectors-4"
              onClick={handleToImg4}
            />
          </div>
        </div>

        <div className="shop-page-section-one-utility">
          <h1 className="shop-page-section-one-utility-name">
            {itemData.name}
          </h1>
          <p className="shop-page-section-one-utility-price">
            {itemData.price}лв.
          </p>

          <div className="shop-page-section-one-utility-addToCart">
            <TextField
              onChange={handleItemCountChange}
              className="shop-page-section-one-utility-addToCart-input"
              type="number"
              InputProps={{ inputProps: { min: 1 } }}
              defaultValue="1"
            ></TextField>
            <button
              onClick={handleFocusItemAddToCart}
              className="shop-page-section-one-utility-addToCart-button"
            >
              Добави
            </button>
            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}>
                <Typography
                  sx={{ color: addItemSiccess === true ? "green" : "red" }}
                  id="modal-modal-title"
                  variant="h6"
                  component="h2"
                >
                  {addItemSiccess === true
                    ? "Артикулът е добавен в количката"
                    : "Моля изберете размер"}
                </Typography>
                <button
                  onClick={handleClose}
                  className="focusitem-modal-close-button"
                >
                  <CheckIcon />
                </button>
              </Box>
            </Modal>
          </div>
          <p className="shop-page-focusItem-categories-p">
            {" "}
            Категории:
            {categories.map((item) => {
              return (
                <Link
                  to={"/"}
                  id={item}
                  // onClick={handleCategoryRedirect}
                  className="shop-page-focusItem-categoryLink"
                >
                  {item},
                </Link>
              );
            })}
          </p>
          <FormControl fullWidth>
            <InputLabel
              sx={{ backgroundColor: "white" }}
              id="demo-simple-select-label"
            >
              Налични размери
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={selectedSize}
              label="sort"
              onChange={handleSelectSize}
            >
              {itemSizes.map((item) => {
                return <MenuItem value={item.size}>{item.size}</MenuItem>;
              })}
            </Select>
          </FormControl>
          {selectedSize === "" ? (
            <></>
          ) : (
            <p
              style={{
                color: availableQuantity === 0 ? "red" : "rgb(2, 85, 31)",
              }}
              className="shop-page-focusItem-availableQunatity-p"
            >
              Налично количество с този размер : {availableQuantity}
            </p>
          )}
        </div>
      </div>
      <div className="shop-page-section-two-container">
        <button
          ref={DescriptionButton}
          className="shop-page-section-two-buttonDescription"
        >
          Описание
        </button>

        <div className="shop-page-section-two-textORform-container">
          <div className="shop-page-section-two-textORform-text-container">
            <p className="shop-page-section-two-textORform-text-p">
              {itemData.description}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
